import { getRequest } from "../../config/axiosConfig";

export const getAdminDashboardStats = async () => {
  try {
    const res = await getRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        `dashboard/stats`,
    });

    if (res?.status === 201 || res?.status === 200 || res?.status === true) {
      return {
        success: true,
        data: res,
        message: "stats get Successfully!",
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid stats getting attempt.",
    };
  }
};